<div class="fb-palette">
  <!-- Tabs -->
  <div class="fb-palette__tabs">
    <button
      class="fb-palette__tab"
      [class.fb-palette__tab--active]="activeTab === 'field'"
      (click)="onTabChange('field')">
      Fields ({{ fieldCount }})
    </button>
    <button
      class="fb-palette__tab"
      [class.fb-palette__tab--active]="activeTab === 'widget'"
      (click)="onTabChange('widget')">
      Widgets ({{ widgetCount }})
    </button>
  </div>

  <!-- Search -->
  <div class="fb-palette__search">
    <i class="fa-solid fa-magnifying-glass fb-palette__search-icon"></i>
    <input
      type="text"
      class="fb-palette__search-input"
      placeholder="Search components..."
      [ngModel]="searchQuery"
      (ngModelChange)="onSearchChange($event)" />
  </div>

  <!-- Items list -->
  <div
    class="fb-palette__list"
    [sortablejs]="filteredItems"
    [sortablejsOptions]="paletteSortableOptions">
    <div
      class="fb-palette__item form-field-types rounded px-3 py-2 mb-2 border border-light-gray"
      *ngFor="let item of filteredItems; trackBy: trackByType"
      (click)="onItemClick(item)"
      [title]="item.type"
      [attr.data-fb-type]="item.type">
      <i class="fa-solid fa-mattress-pillow fb-palette__item-icon"></i>
      <span class="fb-palette__item-name">{{ item.displayName }}</span>
      <i class="fa-solid fa-grip-vertical fb-palette__item-drag"></i>
    </div>
  </div>
  <div *ngIf="filteredItems.length === 0" class="fb-palette__empty">
    <i class="fa-solid fa-search"></i>
    <span>No components found</span>
  </div>
</div>
